import { TypeClientStore } from '../../SubscriptionPlans/store/selectedStore';

export interface IOption {
  id: string | null;
  label: string | null;
  type: string | null;
  value: string | null;
  isChecked: boolean | null;
}

export interface IPaginationParam {
  selected?: number;
}

export interface IPushState {
  user?: string;
  location?: string;
  type?: string | null;
  selectedPage?: number;
}

export interface TransactionsProps {
  user?: any;
  locale?: any;
  selectedStore?: TypeClientStore;
  search?: string;
  type: TransactionsType;
}

export interface TransactionsState {
  isLoading: boolean;
  source: object[];
  totalCounter: number;
  printableData: object[];
  showNoOptions: boolean;
  selectedOrdering: IOption | null;
  filterCityOptions: object[];
  filterStatusOptions: object[];
  orderingOptions: IOption[];
  activeFilters: object[];
  params: {
    page: number;
    take: number;
    totalPages: number;
    searchBoxValue?: string;
    selectedOrdering: IOption | null;
    selectedStatusType?: FilterParam | null;
  };
}

export interface FilterParam {
  value: number | null | string;
  label: string;
}

export enum TransactionsType {
  SALES = 'sales',
  ORDERS = 'purchases',
}

export enum TRANSACTION_STATUS {
  AWAITING_PAYMENT = 1,
  ON_ANALYSIS = 2,
  PAID = 3,
  AVAILABLE = 4,
  ON_DISPUTE = 5,
  RETURNED = 6,
  CANCELED = 7,
  DEBITED = 8,
  ON_HOLD = 9,
}
